import { Statuses } from "./Statuses";

export const FormData = [
  {
    id: 1,
    name: "name",
    placeholder: "Name",
    type: "text",
  },
  {
    id: 2,
    name: "phone",
    placeholder: "Phone",
    type: "text",
  },
  {
    id: 3,
    name: "email",
    placeholder: "Email",
    type: "email",
  },
  {
    id: 4,
    name: "password",
    placeholder: "Password",
    type: "text",
  },
  {
    id: 5,
    name: "birthDate",
    placeholder: "Date Of Birth",
    type: "date",
  },
  // {
  //     id: 6,
  //     name: "qualification",
  //     placeholder: "Qualification",
  //     type: "text"
  // },
  {
    id: 7,
    name: "enquiryRoute",
    placeholder: "Enquiry route",
    type: "text",
  },
];

export const Office = [
  {
    id: 1,
    name: "Head Office",
  },
  {
    id: 2,
    name: "Branch A",
  },
  {
    id: 3,
    name: "Branch B",
  },
  {
    id: 4,
    name: "Branch C",
  },
];

export const EmpFormData = [
  {
    id: 1,
    name: "name",
    placeholder: "Name",
    type: "text",
  },
  {
    id: 2,
    name: "phone",
    placeholder: "Phone",
    type: "text",
  },
  {
    id: 3,
    name: "email",
    placeholder: "Email",
    type: "email",
  },
  {
    id: 4,
    name: "password",
    placeholder: "Password",
    type: "text",
  },
  {
    id: 5,
    name: "birthDate",
    placeholder: "Date Of Birth",
    type: "date",
  },
  {
    id: 6,
    name: "education",
    placeholder: "Education",
    type: "text",
  },
];

export const Address = [
  {
    id: 1,
    name: "houseName",
    placeholder: "House Name",
    type: "text",
  },
  {
    id: 2,
    name: "city",
    placeholder: "City",
    type: "text",
  },
  {
    id: 3,
    name: "state",
    placeholder: "State",
    type: "test",
  },
  {
    id: 4,
    name: "pin",
    placeholder: "PIN",
    type: "text",
  },
];

export const countries = [
  { id: 1, name: "Austria" },
  { id: 2, name: "Australia" },
  { id: 3, name: "Belgium" },
  { id: 4, name: "Canada" },
  { id: 5, name: "China" },
  { id: 6, name: "Cyprus" },
  { id: 7, name: "Denmark" },
  { id: 8, name: "Dubai" },
  { id: 9, name: "Egypt" },
  { id: 10, name: "Finland" },
  { id: 11, name: "France" },
  { id: 12, name: "Georgia" },
  { id: 13, name: "Germany" },
  { id: 14, name: "Hungary" },
  { id: 15, name: "India" },
  { id: 16, name: "Ireland" },
  { id: 17, name: "Italy" },
  { id: 18, name: "Japan" },
  { id: 19, name: "Latvia" },
  { id: 20, name: "Lithuania" },
  { id: 21, name: "Malaysia" },
  { id: 22, name: "Malta" },
  { id: 23, name: "Mauritius" },
  { id: 24, name: "Netherlands" },
  { id: 25, name: "New Zealand" },
  { id: 26, name: "Poland" },
  { id: 27, name: "Russia" },
  { id: 28, name: "Saudi" },
  { id: 29, name: "Singapore" },
  { id: 30, name: "South Korea" },
  { id: 31, name: "Spain" },
  { id: 32, name: "Sweden" },
  { id: 33, name: "Switzerland" },
  { id: 34, name: "Turkey" },
  { id: 35, name: "United Kingdom" },
  { id: 36, name: "United States of America" },
  { id: 37, name: "Vietnam" },
];

export const Intake = [
  { id: 1, name: "Fall" },
  { id: 2, name: "Spring" },
  { id: 3, name: "Winter" },
  { id: 4, name: "Summer" },
  { id: 5, name: "January" },
  { id: 6, name: "February" },
  { id: 7, name: "March" },
  { id: 8, name: "April" },
  { id: 9, name: "May" },
  { id: 10, name: "June" },
  { id: 11, name: "July" },
  { id: 12, name: "August" },
  { id: 13, name: "September" },
  { id: 14, name: "October" },
  { id: 15, name: "November" },
  { id: 16, name: "December" },
];

export const FilterData = [];

export const FilterDataDash = [];

export const Phases = [
  { id: 1, name: "pending" },
  { id: 2, name: "ongoing" },
  { id: 3, name: "completed" },
  { id: 4, name: "deffered" },
  { id: 5, name: "cancelled" },
  { id: 6, name: "not-enrolled" },
  { id: 7, name: "offer letter waiting" },
  { id: 8, name: "offer letter received" },
];
